export default "__VITE_ASSET__DVWAJ0Qq__"